module.exports = __webpack_public_path__ + "img/xzjkjt.bfa9bb29.jpg";